import { render, staticRenderFns } from "./UjianMapel.vue?vue&type=template&id=5585259b&scoped=true"
import script from "./UjianMapel.vue?vue&type=script&lang=js"
export * from "./UjianMapel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5585259b",
  null
  
)

export default component.exports